module.exports = {
  "id": "59ad1148-a606-4a78-84c1-3801dcc29930",
  "gtmIds": [
    "GTM-KJ47BHMC",
    "GTM-T2TNT6",
    "GTM-KKS578WK"
  ],
  "startTracking": "after_accepting_cookies",
  "hasInAppVersion": false,
  "group": "moreys",
  "language": "en-US",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US"
  ],
  "website": "https://www.thestarlux.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}